

exports.__esModule = true;
exports.venmoExperience = exports.venmoInfo = exports.VENMO_OPTIONS = undefined;

var _angular = require('angular');

var _index = require('xo-device-info/dist/index');

var _squid = require('squid');

var _auth = require('xo-models/src/auth');

var _checkout = require('xo-models/src/checkout');

var _sessionStorage = require('./sessionStorage');

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

var _logger = require('xo-beaver/dist/logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// TODO: Check how the cookie should be read/set (through meta? if read on server side)
var PWV_COOKIE = 'pwv';
var VENMO_SETUP_COOKIE = 'venmoSetup';

var VENMO_OPTIONS = exports.VENMO_OPTIONS = {
    PAYPAL: 'PAYPAL',
    VENMO: 'VENMO'
};

var venmoInfo = exports.venmoInfo = {
    // Handler to call to determine if user can use Venmo
    isVenmoEligible: function isVenmoEligible() {

        var venmoRegex = new RegExp('(?:^|; )' + PWV_COOKIE + '=1(?:;|$)');
        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
        var merchantID = _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId();
        var isVenmoBillingWhitelisted = _squid.$config.venmoBillingWhitelist && _squid.$config.venmoBillingWhitelist.indexOf(merchantID) > -1;

        var merchantCountry = appData.get('merchant.merchant_country');
        var isProcessorDeclined = appData.get('flags.processor_declined');
        var isInvoice = appData.get('flags.is_invoice_flow');
        // check if whitelisted, else honor billing address flag
        var isBillingRequired = isVenmoBillingWhitelisted ? false : appData.get('flags.billing_address_consent_required'); // eslint-disable-line no-unused-vars
        var isOrderTransaction = cart.get('payment_action') === 'order';
        var isBillingAgreement = cart.isBilling();

        var isMobile = _index.$DeviceInfo.isDevice();
        var isVenmoCookiePresent = Boolean(document.cookie.match(venmoRegex));

        var eligibilityParams = {
            isMobile: isMobile,
            isVenmoCookiePresent: isVenmoCookiePresent,
            isNotInvoice: !isInvoice,
            isNotProcessorDeclined: !isProcessorDeclined,
            isNotOrderTransaction: !isOrderTransaction,
            isNotBillingAgreement: !isBillingAgreement,
            isUSMerchant: merchantCountry === 'US'
        };

        var venmoEligibility = Object.keys(eligibilityParams).filter(function (param) {
            return !eligibilityParams[param];
        });
        venmoEligibility = venmoEligibility && venmoEligibility.length > 0 ? 'ineligible:' + venmoEligibility.join() : 'eligible';

        _logger.$logger.info('venmo_eligibility', venmoEligibility);

        _logger.$logger.info('checkout_fpti', {
            'is_venmo_cookie': isVenmoCookiePresent ? '1' : '0',
            'eligibility_reason': venmoEligibility
        });

        return Boolean(venmoEligibility === 'eligible');
    },


    // Get option user has selected for Venmo, return null if user has not set up yet.
    venmoState: function venmoState() {
        var setupRegex = new RegExp('(?:^|; )' + VENMO_SETUP_COOKIE + '=(\\w*)(?:;|$)');
        var match = document.cookie.match(setupRegex);

        if (match && VENMO_OPTIONS.hasOwnProperty(match[1])) {
            return match[1];
        } else {
            return null;
        }
    },


    // Delete the venmo state cookie
    clearVenmoState: function clearVenmoState() {
        document.cookie = VENMO_SETUP_COOKIE + '=; Max-Age=0';
    },
    setVenmoCookie: function setVenmoCookie() {
        document.cookie = VENMO_SETUP_COOKIE + '=' + VENMO_OPTIONS.VENMO;
    },
    setPayPalCookie: function setPayPalCookie() {
        document.cookie = VENMO_SETUP_COOKIE + '=' + VENMO_OPTIONS.PAYPAL;
    },


    // Build the venmo URL scheme
    buildVenmoURL: function buildVenmoURL() {
        var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL;
        var VENMO_ROUTE = '#/checkout/venmo';
        var LOGIN_ROUTE = '#/checkout/login?venmoError=true';

        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);

        var params = (0, _angular.$httpParamSerializer)({
            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
            'ua': _angular.$window.navigator.userAgent,
            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
            'token': _angular.$rootScope.token,
            'total': cartModel.purchase.amounts.total.amount,
            'currency': cartModel.purchase.amounts.total.currency_code,
            'intent': cartModel.payment_action
        });

        return SCHEME + 'paypal/checkout?' + params;
    }
};

var venmoExperienceKey = 'VENMO_EXPERIENCE';

// Get whether a token is marked as Venmo experience.
var venmoExperience = exports.venmoExperience = {
    set: function set(token) {
        var sessionStorage = (0, _sessionStorage2['default'])();
        sessionStorage.setItem(venmoExperienceKey, token);
    },
    get: function get(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();
        if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
        sessionStorage.getItem(venmoExperienceKey) === token) {
            return true;
        } else {
            this.set(null);
            return false;
        }
    }
};

_angular.$rootScope;

_angular.$window;

_angular.$location;

_angular.$httpParamSerializer;

_index.$DeviceInfo;

_squid.$config;

_auth.$AuthModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./components/xo-venmo-components/src/venmo-info/index.js
// module id = ./components/xo-venmo-components/src/venmo-info/index.js
// module chunks = 1